import { render, staticRenderFns } from "./DialogSysDictType.vue?vue&type=template&id=fb33fe26&"
import script from "./DialogSysDictType.vue?vue&type=script&lang=js&"
export * from "./DialogSysDictType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports